import { UserModel } from "src/app/models/user";

export interface UserState
{
    user: UserModel;
}

export const USER_FEATURE_KEY = 'user';